module.exports = __webpack_public_path__ + "img/Shuax.69e9f790.svg";